module.exports = __webpack_public_path__ + "img/title.6a3a68da.png";